import React from "react";

export const Info = () => {
  return (
    <div className="infoFlex">
      <div className="infoContent">
        <h1 className="title">報名簡章</h1>
        <a
          style={{ margin: "0 0 0.5rem 0" }}
          href="https://docs.google.com/document/d/1QxxEyikRJzmLz5Pdet_ghNhzKDaeHj7LOmZQhwjXoS8/edit?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          Google Docs 版本
        </a>
        <p>修訂日期：2023 年 4 月 24 日</p>
        <hr className="bar"></hr>
        <div className="mainInfo">
          <p>
            同學、家長您好：
            <br />
            很高興您有意願報名參加國立師範大學 2023 暑期資工營 ｢Challenger Surviving Islands: E
            級玩家」。以下我們將向各位說明本營隊的相關資訊：
          </p>
          <p>
            <ol>
              <li>營隊時間：2023 年 7 月 3 日 (星期一) 至 2023 年 7 月 7 日 (星期五)</li>
              <li>營隊地點：國立臺灣師範大學公館校區 (臺北市文山區汀洲路四段 88 號)</li>
              <li>住宿地點：旅居文旅--台北松山機場館(104 台北市中山區松江路485號)</li>
              <li>主辦單位：國立臺灣師範大學資訊工程學系</li>
              <li>招收對象：現為全國公私立高中高職學生及國高中應屆畢業生</li>
              <li>招收名額：共 64 名</li>
              <li>
                活動費用：8900 元整 (含食宿、保險)
                <br />
                早鳥優惠(即日起至 5/22 )：8600 元整 (含食宿、保險)
              </li>
              <li>報名方法：線上報名</li>
            </ol>
          </p>
          <p>
            一、 報名日期：
            <br />
            <ol>
              <li>第一階段：2023 年 4 月 24 日 至 2023 年 5 月 26 日 </li>
              <li>第二階段：2023 年 6 月 01 日 至 2023 年 6 月 09 日 </li>
            </ol>
            (報名時間以線上網站登記時間為憑)
          </p>
          <p>
            二、 報名程序：
            <ol>
              <li>
                4/24 至 5/26 開放第一階段報名，6/1 至 6/9 為第二階段報名，5/30 將於粉專公佈第
                一階段錄取名單，6/12 公佈第二階段錄取名單。
              </li>
              <li>
                第一階段錄取後即可開始繳費，請在截止日期 6/8 前完成繳費，第二階段錄取的學員繳費
                期限為 6/20。將活動費用匯款至以下帳戶：
                <ul>
                  <li>郵局代碼：700</li>
                  <li>戶名：國立台灣師範大學資訊工程系學會許芯瑜 </li>
                  <li>帳號：0001972 0101705 </li>
                </ul>
                完成匯款手續同學請至官方網站登記匯款資料，所需資料如下：
                <ul>
                  <li>學生姓名</li>
                  <li>轉帳/匯款日期</li>
                  <li>帳戶名稱</li>
                  <li>帳號後五碼</li>
                </ul>
                (請注意您的繳費期限，若於期限內未完成匯款，即喪失參加資格。)
              </li>
              <li>繳費完成後請等待行前通知 (將於6/26~6/30 送出)，並且至官方網站繳交家長同意書。</li>
            </ol>
          </p>
          <p>
            三、 退費標準：
            <ol>
              <li>營期開始前，若遇天災或不可抗力之情事致使營隊無法如期舉辦，可退還全額之 90%。</li>
              <li>
                營期間，若遇天災或不可抗力之情事得由主辦單位提前結束，以確保學員安全。相關退費辦法如下：
                <ul>
                  <li>若在營期之第 1~2 天中止活動，則退還全額之 30%。</li>
                  <li>
                    若在營期之第 3~5 天中止活動，因活動費用已支出，唯餐費可退還，其餘恕不退費。
                  </li>
                </ul>
              </li>
              <li>
                營隊開始前，已完成繳費手續之學員，因故無法參與活動可依規定辦理退費，相關退費事宜
                如下：
                <ul>
                  <li>於最後繳費截止前(2023 年 6 月 20 日)提出申請者，可全額退費。</li>
                  <li>於 2023 年 6 月 21 日至營期前提出申請者，可退還全額之 50%。</li>
                  <li>申請日期以信件寄達郵戳日期計。</li>
                </ul>
              </li>
              <li>
                營期間，若因學員個人因素未完整參與活動，因流程已開始進行，費用恕不退還，若有不便敬請見諒。
              </li>
            </ol>
          </p>
          <p>
            四、 注意事項：
            <ol>
              <li>
                營期間，學員不可擅自離開活動地點，若因個人因素必須離開營隊活動地點，必須簽下離營安全保證書並聯絡其家長。離開營隊之後，學員一切安全事項，本營隊恕不負責。
              </li>
            </ol>
          </p>
          <p>
            五、 聯絡方式：
            <ol>
              <li>總籌：張建堯 連絡電話：0978-935-279</li>
              <li>
                Email：<a href="mailto:camp@csie.cool">camp@csie.cool</a> (或
                ntnucsiecamp2023@gmail.com)
              </li>
              <li>
                官方網站：
                <a href="https://camp.ntnucsie.info/2023">https://camp.ntnucsie.info/2023</a>
              </li>
              <li>
                官方粉專：
                <a href="https://www.facebook.com/ntnucsiecamp" target="_blenk">
                  https://www.facebook.com/ntnucsiecamp
                </a>
              </li>
            </ol>
          </p>
        </div>
        <div className="registerButton">
          <a href="https://camp-app.csie.cool/login" target="_blank" rel="noreferrer">
            <button className="register">立即報名</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Info;
